import { useEffect } from 'react'

const PIXEL_ID = '3402382169937662'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

/**
 * Injects the Meta (Facebook) Pixel script and fires a single PageView event.
 * Safe to call multiple times — the snippet guards against re-injection.
 */
export function useMetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return

    // If pixel already initialized, just fire PageView (e.g. SPA navigation)
    if (window.fbq) {
      window.fbq('track', 'PageView')
      return
    }

    // Official Meta Pixel base code (async loader)
    // We append to <head> directly instead of inserting before the first
    // existing <script>, because bundled/module SPAs may have no script tags
    // in the static DOM at the moment this effect runs.
    ;(function (f: any, b: Document, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement('script') as HTMLScriptElement
      t.async = true
      t.src = v
      const target = b.head || b.body || b.documentElement
      target.appendChild(t)
    })(window, document, 'https://connect.facebook.net/en_US/fbevents.js')

    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')

    // <noscript> fallback for users with JS disabled
    if (!document.getElementById('meta-pixel-noscript')) {
      const noscript = document.createElement('noscript')
      noscript.id = 'meta-pixel-noscript'
      const img = document.createElement('img')
      img.height = 1
      img.width = 1
      img.style.display = 'none'
      img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
      img.alt = ''
      noscript.appendChild(img)
      document.body.appendChild(noscript)
    }
  }, [])
}
